module.exports = __webpack_public_path__ + "static/media/ic weather 22.8d4394b3.png";